"use client";

import dynamic from 'next/dynamic';
import styles from "./SoMe.module.css";
import ErrorBoundary from "@/components/framework/errorboundary/ErrorBoundary";

//#region [Props]
type TwitterProps = {
    value: {
        twitterUserId: string;
        twitterPostId: string;
    }
};
//#endregion

//#region [Component]
const DynamicTwitterEmbed = dynamic(() =>
    import('react-social-media-embed').then((mod) => mod.XEmbed),
    { ssr: false }
);

export default function Twitter({ value }: TwitterProps) {
    if (!value?.twitterUserId || !value?.twitterPostId) {
        return null;
    }
    return <div className={styles.container}>
        <ErrorBoundary>
            <DynamicTwitterEmbed url={`https://twitter.com/${value.twitterUserId}/status/${value.twitterPostId}`} width="100%" />
        </ErrorBoundary>
    </div>;
}
//#endregion